import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import HomeHeroSection from '../components/home/HomeHeroSection';
import ElfsightWidget from '../components/about/ElfsightWidget';
import SEOHead from '../components/SEOHead';

const Index = () => {
  const homeJsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "ParadoxEdge",
      "description": "Executive coaching and leadership development for leaders ready to grow through continuous practice.",
      "url": "https://www.paradoxedge.com",
      "logo": "https://www.paradoxedge.com/lovable-uploads/180210a9-9a73-4038-a36b-f373598ef48a.png",
      "image": "https://www.paradoxedge.com/og-image.png?v=3",
      "priceRange": "$$$$",
      "serviceType": ["Executive Coaching", "Leadership Development", "Vertical Development", "Organizational Development"],
      "areaServed": "Worldwide",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Denver",
        "addressRegion": "CO",
        "addressCountry": "US"
      },
      "founder": {
        "@type": "Person",
        "name": "Kent Frazier",
        "jobTitle": "Founder & CEO",
        "url": "https://www.linkedin.com/in/kent-frazier/"
      },
      "sameAs": [
        "https://www.linkedin.com/company/90481320",
        "https://www.linkedin.com/in/kent-frazier/"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "ParadoxEdge",
      "url": "https://www.paradoxedge.com",
      "inLanguage": "en-US",
      "publisher": { "@type": "Organization", "name": "ParadoxEdge" }
    }
  ];

  return (
    <>
      <SEOHead
        title="Executive Coaching & Leadership Development | ParadoxEdge"
        description="Executive coaching for leaders ready to grow through continuous practice. More views. New ways. Inspired outcomes."
        canonicalUrl="/"
        keywords="executive coaching, leadership development, vertical development, presence-based coaching, executive development, leadership training"
        jsonLd={homeJsonLd}
      />
      <div className="min-h-screen bg-background flex flex-col">
        <Navigation />
        <ElfsightWidget />
        <main className="flex-1">
          <HomeHeroSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
